import React, { useEffect, useRef, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";

import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { API_URL_LOCAL } from "..";

const DepartmentsPage = () => {
  const tableRef = useRef(null);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [newDepartment, setNewDepartment] = useState({ name: "", locationId: null });
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);

  // Fetch locations and departments
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) {
          throw new Error("User not found in localStorage");
        }

        // Fetch locations
        const locResponse = await axios.get(`${API_URL_LOCAL}/api/company/fetch/${user.id}`);
        const locOptions = locResponse.data.companies.map((loc) => ({
          value: loc.id,
          label: loc.title,
        }));
        setLocations(locOptions);

        // Fetch departments
        const depResponse = await axios.get(`${API_URL_LOCAL}/api/departments/fetch/${user.id}`);
        setDepartments(depResponse.data.departments || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (!departments.length || !tableRef.current) return;

    const table = $(tableRef.current).DataTable({
      data: departments,
      columns: [
        {
          title: "Department Name",
          data: "name",
        },
        {
          title: "Location",
          data: "location",
          render: (data) => {
            const location = departments.find((d) => d.location === data)?.companyLocation;
            return location ? location.title || location.label : "Unknown";
          },
        },
        {
          title: "Actions",
          data: null,
          render: (data, type, row) => `
            <button class="btn btn-sm btn-primary view-btn" data-id="${row.id}">View</button>
            <button class="btn btn-sm btn-danger delete-btn ms-2" data-id="${row.id}">Delete</button>
          `,
          orderable: false,
        },
      ],
      responsive: true,
      destroy: true,
    });

    // Handle View and Delete button clicks
    $(tableRef.current).on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const dept = departments.find((d) => d.id === id);
      setSelectedDepartment({
        id: dept.id,
        name: dept.name,
        locationId: dept.location,
      });
      setShowViewModal(true);
    });

    $(tableRef.current).on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      setDepartmentToDelete(id);
      setShowDeleteConfirm(true);
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [departments]);

  // Handle Add Department
  const handleAddDepartment = async () => {
    if (!newDepartment.name || !newDepartment.locationId) {
      alert("Please fill all fields");
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const payload = {
        name: newDepartment.name,
        location: newDepartment.locationId, // Matches API field "location"
        org_id: user.id,
      };
      const response = await axios.post(`${API_URL_LOCAL}/api/departments/create`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201) {
        // Mock companyLocation for new department (replace with actual API response if it includes it)
        console.log(response.data)
        const newDept = {
          id: response.data.department.id,
          name: payload.name,
          location: payload.location,
          companyLocation: locations.find((loc) => loc.value === payload.location) || {
            title: "Unknown",
          },
        };
        setDepartments([...departments, newDept]);
        setNewDepartment({ name: "", locationId: null });
        setShowAddModal(false);
      }
    } catch (err) {
      alert("Failed to add department: " + err.message);
    }
  };

  // Handle Save Changes
  const handleSaveChanges = async () => {
    if (!selectedDepartment.name || !selectedDepartment.locationId) {
      alert("Please fill all fields");
      return;
    }

    try {
      const payload = {
        name: selectedDepartment.name,
        location: selectedDepartment.locationId, // Matches API field "location"
      };
      const response = await axios.put(
        `${API_URL_LOCAL}/api/departments/update/${selectedDepartment.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {

        setDepartments(
          departments.map((d) =>
            d.id === selectedDepartment.id
              ? {
                  ...d,
                  name: selectedDepartment.name,
                  location: selectedDepartment.locationId,
                  companyLocation: locations.find((loc) => loc.value === selectedDepartment.locationId) || d.companyLocation,
                }
              : d
          )
        );
        setShowViewModal(false);
      }
    } catch (err) {
      alert("Failed to save changes: " + err.message);
    }
  };

  // Handle Delete Department
  const handleDeleteDepartment = async () => {
    try {
      const response = await axios.delete(
        `${API_URL_LOCAL}/api/departments/delete/${departmentToDelete}`
      );

      if (response.status === 200) {
        
        const vak = departments.filter((d) => d.id !== departmentToDelete);
        if(vak.length == 0){
          window.location.reload();
        }else{
          setDepartments(departments.filter((d) => d.id !== departmentToDelete));
        }
        setShowDeleteConfirm(false);
        setDepartmentToDelete(null);
      }
    } catch (err) {
      alert("Failed to delete department: " + err.message);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Departments" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="d-flex justify-content-end mb-20">
            <Button
              variant="primary"
              className="border border-primary-600 text-md px-24 py-8 radius-8"
              onClick={() => setShowAddModal(true)}
            >
              Add Department
            </Button>
          </div>
          {loading && <div className="text-center">Loading...</div>}
          {error && (
            <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
              {error}
            </div>
          )}
          {!loading && !error && (
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>Department Name</th>
                    <th>Location</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Add Department Modal */}
      <Modal style={{marginTop: 80}} show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Add New Department</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Department Name <span className="text-danger-600">*</span>
            </label>
            <input
              type="text"
              className="form-control radius-8"
              value={newDepartment.name}
              onChange={(e) => setNewDepartment({ ...newDepartment, name: e.target.value })}
              placeholder="Enter Department Name"
            />
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Location <span className="text-danger-600">*</span>
            </label>
            <Select
              options={locations}
              value={locations.find((loc) => loc.value === newDepartment.locationId)}
              onChange={(selected) =>
                setNewDepartment({ ...newDepartment, locationId: selected?.value || null })
              }
              placeholder="Select Location"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddDepartment}>
            Add Department
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View/Edit Department Modal */}
      <Modal show={showViewModal} style={{marginTop: 80}} onHide={() => setShowViewModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>View/Edit Department</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDepartment && (
            <>
              <div className="mb-3">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Department Name <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  value={selectedDepartment.name}
                  onChange={(e) =>
                    setSelectedDepartment({ ...selectedDepartment, name: e.target.value })
                  }
                  placeholder="Enter Department Name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Location <span className="text-danger-600">*</span>
                </label>
                <Select
                  options={locations}
                  value={locations.find((loc) => loc.value === selectedDepartment.locationId)}
                  onChange={(selected) =>
                    setSelectedDepartment({
                      ...selectedDepartment,
                      locationId: selected?.value || null,
                    })
                  }
                  placeholder="Select Location"
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteConfirm} style={{marginTop: 80}} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Confirm Delete</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this department?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDeleteDepartment}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default DepartmentsPage;